module.exports = __webpack_public_path__ + "img/vertical_7_3_8019.384395d1.png";